import { Result } from "../models/result";
import { log } from "./logger";
import { client } from "./nats-client";

const tag = "ReleaseInfo";

async function GetPlatformVersion() {
  const platformInfo = (await client.request("releaseinfo.get.application", {})) as Result<any>;
  if (!platformInfo?.success) {
    log.error(tag, "Service releaseinfo.get-application failed", platformInfo?.reasons);
    return null;
  }
  return platformInfo?.data;
}

async function GetMetadataVersion() {
  const metadataInfo = (await client.request("releaseinfo.get.metadata", {})) as Result<any>;
  if (!metadataInfo?.success) {
    log.error(tag, "Service releaseinfo.get-metadata failed", metadataInfo?.reasons);
    return null;
  }
  return metadataInfo?.data;
}

function GetSDKVersion() {
  return {
    BranchName: import.meta.env.VITE_GIT_BRANCH,
    CommitSha: import.meta.env.VITE_GIT_COMMIT_SHA,
  }
}


async function GetReleaseInfoState() {
  return {
    ATier: await GetPlatformVersion(),
    PTier: await GetMetadataVersion(),
    SDKTier: GetSDKVersion(),
  }
}

export {
  GetMetadataVersion,
  GetPlatformVersion,
  GetReleaseInfoState,
  GetSDKVersion
}